import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import Field from "../../../../../../../components/Field";
import SubSection from "./SubSection";
import { getCustomFieldInput } from "../../../../../components/TimeSheetTable/useColumns/useCustomFieldsColumns";
import { useCustomFields } from "../../../../../../Settings/CustomFields/context";

const CustomFieldInput = ({ config, value, onChange }) => {
    return getCustomFieldInput({ config, value, onChange });
}

function CustomFields() {
    const { t } = useTranslation();
    const { timesheetCustomFields, isTimesheetLoading } = useCustomFields();

    return (
        timesheetCustomFields?.length > 0 && (
            <SubSection title={t("custom-fields")} loading={isTimesheetLoading}>
                <Row>
                    {timesheetCustomFields?.map((customField, i) => {
                        const isOdd = timesheetCustomFields.length % 2 !== 0;
                        const isLast = (timesheetCustomFields.length - 1) === i;
                        const size = isOdd && isLast ? 12 : 6;

                        return (
                            <Col md={size} key={customField.id}>
                                <Field
                                    key={customField.code}
                                    name={["customFields", customField.code]}
                                    label={customField.description}
                                >
                                    <CustomFieldInput config={customField} />
                                </Field>
                            </Col>
                        );
                    })}
                </Row>
            </SubSection>
        )
    );
}

export default CustomFields;
